import { put, takeEvery } from 'redux-saga/effects';
import { ActionType } from 'typesafe-actions';

import { INewsResponse } from 'ApiPackage/NewsModule/interfaces/INewsResponse';
import { getNews } from 'ApiPackage/NewsModule/services/news';
import { compareDates } from 'CorePackage/MainModule/common/formatDate';
import { DATE_FORMAT_ISO } from 'CorePackage/MainModule/constants/dateFormat';
import { ROUTE_NEWS } from 'CorePackage/MainModule/constants/routes';
import { sagaWrapper } from 'CorePackage/MainModule/common/sagaWrapper';

import { newsGetData, newsSetData } from '../actions/newsActions';
import { NewsActionsEnum } from '../enums/NewsActionsEnum';
import { NewsTypesEnum } from '../enums/NewsTypesEnum';

function* newsGetDataSaga(action: ActionType<typeof newsGetData>) {
  function* funcTry() {
    const { type } = action.payload;
    const news: INewsResponse = yield getNews({
      size: !window.location.pathname.includes(ROUTE_NEWS) && !type ? 3 : undefined,
      type: type || NewsTypesEnum.NEWS,
    });
    if (news && news.content) {
      yield put(
        newsSetData(
          news.content.filter(
            item =>
              compareDates({
                dateLeft: item.created || '',
                dateRigth: item.expired || '',
                parseFormat: DATE_FORMAT_ISO,
              }) !== 1,
          ),
          type || NewsTypesEnum.NEWS,
        ),
      );
    }
  }

  yield sagaWrapper({
    funcTry,
  });
}

export function* watchNewsSaga() {
  yield takeEvery(NewsActionsEnum.NEWS_GET_DATA, newsGetDataSaga);
}
